import { render, staticRenderFns } from "./licenseContract.vue?vue&type=template&id=067cb2d8&scoped=true"
import script from "./licenseContract.vue?vue&type=script&lang=js"
export * from "./licenseContract.vue?vue&type=script&lang=js"
import style0 from "./licenseContract.vue?vue&type=style&index=0&id=067cb2d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067cb2d8",
  null
  
)

export default component.exports